import { paymentListSchema, type ListPaymentsQuery, type PaymentList } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const searchOf = (query: ListPaymentsQuery): string => {
  if (query.status === undefined) {
    return '';
  }
  return `?${new URLSearchParams({ status: query.status }).toString()}`;
};

const fetchPayments = (query: ListPaymentsQuery, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/payments${searchOf(query)}`, { signal });

export const getPayments = async (
  query: ListPaymentsQuery,
  signal: AbortSignal,
): Promise<PaymentList> => paymentListSchema.parse(await fetchPayments(query, signal));
